module.exports = __webpack_public_path__ + "static/media/es-share-image.a69a7a7b.jpg";